import { FormControl, FormGroup } from '@angular/forms';
import { updateHistorySearch } from '../../../shared/components/pagination/pagination.utils';


export class PaginationConsumer {
  filters = new FormGroup({
    page: new FormControl(null),
  });
  prevFilters: object;
  itemsTo: number;
  itemsFrom: number;
  currentPage: number = 1;
  lastPage: number;
  totalRows: number;
  isLoading: boolean = true;

  handlePageInput(page: number) {
    this.currentPage = page;
    this.handlePageChange();
  }

  nextPage() {
    this.currentPage++;
    this.handlePageChange();
  }

  prevPage() {
    this.currentPage--;
    this.handlePageChange();
  }

  handlePageChange() {
    this.isLoading = true;
    this.filters.get('page').setValue(this.currentPage);
    updateHistorySearch(this);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/pagination/pagination-consumer.component.ts